// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__kzjDs","white":"styles_white__1xrCX","sticky":"styles_sticky__3VuDC","header":"styles_header__zGT86","logo":"styles_logo__1nDkA"};